import { Autocomplete, TextField, Tooltip } from 'components/mui';
import { ROLES } from 'containers/pages/users/constants';
import Chip from '@mui/material/Chip';
import { GroupHeader, GroupItems } from './StyledRoleGroup';
import { array, func, object } from 'prop-types';
import { useEffect, useState } from 'react';
import removeDuplicatedValues from '../../libs/removeDuplicatedValues';

/**
 * @component RoleGroupSelector
 * @param {Object} props
 * @param {object} props.user
 * @param {object} props.valid
 * @param {array} props.options
 * @param {function} props.handleForm
 * @param {array} props.fixedOptions
 * @returns {JSX.Element}
 */
function RoleGroupSelector({ user, valid, options, handleForm, fixedOptions }) {
	const [groups, setGroups] = useState([...options]);
	const [fixedGroups, setFixedGroups] = useState([...fixedOptions]);
	const [values, setValues] = useState([...user[ROLES]]);

	const onChange = (e, newValues) => {
		const result = removeDuplicatedValues(newValues);
		e.target.name = ROLES;
		handleForm(e, result);
	};

	useEffect(() => {
		setGroups([...options]);
		setFixedGroups([...fixedOptions]);
		setValues([...user[ROLES]]);
	}, [fixedOptions, options, user]);

	return (
		<>
			<Autocomplete
				multiple
				value={values}
				options={groups}
				groupBy={(option) => option.appName}
				disableClearable
				getOptionLabel={(option) => (option.name ? option.name : '')}
				onChange={onChange}
				renderGroup={(params) => (
					<li key={params.key}>
						<GroupHeader>{params.group}</GroupHeader>
						<GroupItems>{params.children}</GroupItems>
					</li>
				)}
				renderInput={(params) => (
					<Tooltip title="This gives the user access to different apps and permissions." arrow>
					<TextField
						{...params}
						variant="outlined"
						required={true}
						label="Role Group"
						InputLabelProps={{ shrink: true }}
						error={valid[ROLES].isErr}
						helperText={valid[ROLES].errMsg}
					/>
					</Tooltip>
				)}
				renderTags={(tagValue, getTagProps) =>
					tagValue.map((option, index) => {
						return (
							<Chip
								label={option.name}
								{...getTagProps({ index })}
								disabled={fixedGroups.indexOf(option) !== -1}
							/>
						);
					})
				}
			/>
		</>
	);
}

RoleGroupSelector.propTypes = {
	user: object,
	valid: object,
	options: array,
	handleForm: func,
	fixedOptions: array,
};

export default RoleGroupSelector;
